import styled from "styled-components";

export const ModalObservation = styled.div`

  @media(min-width: 768px) {
    padding: 1rem 1.5rem 1.5rem 1.5rem;
  }

  div {
    display: flex;
    justify-content: space-between;
  }

  h4 {
    font-size: 1rem;
    color: #000FFF;
    font-weight: 500;
  }

  textarea {
    width: 100%;
    border: 1px solid #00000034;
    border-radius: .5rem;
    resize: none;
    padding: .5rem;
    height: 8rem;
    margin: .5rem 0 0 0;
  }
`;

export const ObservationContent = styled.div`
  padding: 1rem;
  font-size: .88rem;
  color: #707070;
`;

export const CardHeader = {
  backgroundColor: "rgb(230, 223, 223)",
  color: "rgb(112, 112, 112)",
  fontSize: ".9rem",
  fontWeight: "550",
  padding: ".2rem 1rem",
  borderTopLeftRadius: ".3rem",
  borderTopRightRadius: ".3rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const ObservationMobile = styled.div`
  @media(min-width: 770px) {
    display: none;
  }
`;

export const ObservationDesktop = styled.div`
  @media(max-width: 770px) {
    display: none;
  }
`;

export const AddIconStyles = {
  fontWeight: "600",
  fontSize: "1.7rem",
}

export const MinimizeIconStyles = {
  fontWeight: "600",
  fontSize: "1.7rem",
  marginTop: "-0.85rem",
}
